/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { EmptyState } from "../components/ui/EmptyState";
import { useChrome } from "../contexts/ChromeContext";

/** What a link to a page that does not exist lands on, inside the shell. */
export function NotFound() {
  useChrome({ title: "Not found" }, []);
  return (
    <div className="grid h-full place-items-center">
      <EmptyState title="Not found" description="This page doesn't exist." />
    </div>
  );
}
